import { render, staticRenderFns } from "./ZonePromotionGoods.vue?vue&type=template&id=048555ec&scoped=true"
import script from "./ZonePromotionGoods.vue?vue&type=script&lang=js"
export * from "./ZonePromotionGoods.vue?vue&type=script&lang=js"
import style0 from "./ZonePromotionGoods.vue?vue&type=style&index=0&id=048555ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048555ec",
  null
  
)

export default component.exports